/* eslint-disable camelcase */
import { Language, LanguageType } from '@nx-smartmonkey/shared/domain';
import { User } from '../../domain/user/User';
import { UserDTO } from '../../domain/user/UserDTO';

export class UserMapper {
  static toDomain(props: UserDTO): User {
    const {
      id,
      avatar_url,
      organization_id,
      default_project_id,
      email,
      first_name,
      last_name,
      phone,
      active,
      roles,
      language,
      validation,
      created_at,
      guide,
      notifications,
      two_factor,
      intercom_hash,
      deleted,
    } = props;

    const languageDomain = Language.create(language as LanguageType);
    return User.create(
      {
        avatar_url,
        organization_id,
        default_project_id,
        email,
        first_name,
        last_name,
        phone,
        active,
        roles,
        language: languageDomain,
        validation: {
          email_validated: validation.email_validated ?? false,
          phone_validated: validation.phone_validated ?? false,
        },
        created_at,
        guide: {
          changelog_version: guide?.changelog_version,
          tutorials: {
            ...(guide?.tutorials?.onboarding
              ? {
                  onboarding: {
                    is_finished: guide.tutorials.onboarding.is_finished,
                    current_step: guide.tutorials.onboarding.current_step,
                  },
                }
              : {}),
          },
        },
        notifications: {
          analytics_email: notifications.analytics_email ?? false,
        },
        two_factor: {
          sms_enabled: two_factor.sms_enabled ?? false,
          email_enabled: two_factor.email_enabled ?? false,
        },
        intercom_hash,
        deleted,
      },
      id
    );
  }
}
